module.exports = __webpack_public_path__ + "8a37d5ab5003b53539366b377860b27b.pdf";